interface UseButtonTrackingProps {
  text: string;
  placement: string;
  targetpath?: string;
}

const useButtonTracking = ({
  text,
  placement = "center",
  targetpath = "#",
}: UseButtonTrackingProps): [
  { "data-tracking-event": "button-impression"; "data-tracking-info": string },
  () => void
] => {
  const trackingInfo = {
    name: text.toLowerCase().replace(/\s/g, "-"),
    text,
    placement,
    targetpath,
  };

  return [
    {
      "data-tracking-event": "button-impression",
      "data-tracking-info": JSON.stringify(trackingInfo),
    },
    () => {
      if (process.env.NODE_ENV === "development") {
        return;
      }

      const tracker = (window as any).analyticstracker();
      const trackingEvent = {
        event: "button-click",
        info: {
          name: text.toLowerCase().replace(/\s/g, "-"),
          text,
          placement,
          targetpath,
        },
      };

      return tracker.trackEvent(trackingEvent);
    },
  ];
};

export default useButtonTracking;
